import React from 'react';

export default function SendConfirmDialog({ open, summary, onConfirm, onCancel }) {
  if (!open || !summary) return null;

  const { totalSelected, willSend, blocked, byChannel, blockedReasons, smsInfo, totalSmsMessages } = summary;

  return (
    <div className="messages-dialog-overlay" role="presentation" onClick={onCancel}>
      <div
        className="messages-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="send-confirm-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 id="send-confirm-title" className="messages-dialog-title">
          אישור שליחה
        </h3>

        <p className="messages-dialog-lead">
          אתה עומד לשלוח הודעה ל-<strong>{totalSelected}</strong> דיירים.
          <br />
          <strong>{willSend}</strong> יישלחו בפועל.
        </p>

        <ul className="messages-dialog-list">
          {byChannel.email > 0 && <li>מייל: {byChannel.email}</li>}
          {byChannel.sms > 0 && (
            <li>
              SMS: {byChannel.sms} נמענים
              {smsInfo.parts > 1 && (
                <> × {smsInfo.parts} SMS = <strong>{totalSmsMessages}</strong> הודעות SMS</>
              )}
            </li>
          )}
          {byChannel.whatsapp > 0 && <li>WhatsApp: {byChannel.whatsapp}</li>}
        </ul>

        {blocked > 0 && (
          <div className="messages-dialog-warning">
            <strong>{blocked}</strong> דיירים לא יישלחו:
            <ul>
              {blockedReasons.noConsent > 0 && (
                <li>{blockedReasons.noConsent} ללא אישור קבלת הודעות</li>
              )}
              {blockedReasons.noContact > 0 && (
                <li>{blockedReasons.noContact} ללא פרטי קשר לערוץ שנבחר</li>
              )}
              {blockedReasons.noChannel > 0 && (
                <li>{blockedReasons.noChannel} ללא ערוץ זמין</li>
              )}
            </ul>
          </div>
        )}

        {summary.activeChannels?.includes('sms') && smsInfo.chars > 0 && (
          <p className="messages-dialog-note">
            אורך SMS: {smsInfo.chars} תווים ({smsInfo.costLabel})
            {smsInfo.isUnicode && ' — עברית נספרת כ-Unicode (70 תווים ל-SMS)'}
          </p>
        )}

        <div className="messages-dialog-actions">
          <button type="button" className="messages-btn messages-btn--secondary" onClick={onCancel}>
            ביטול
          </button>
          <button
            type="button"
            className="messages-btn messages-btn--primary"
            onClick={onConfirm}
            disabled={willSend === 0}
          >
            אשר ושלח
          </button>
        </div>
      </div>
    </div>
  );
}
